import { render, staticRenderFns } from "./VideoPager.vue?vue&type=template&id=0720cc30&"
import script from "./VideoPager.vue?vue&type=script&lang=js&"
export * from "./VideoPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0720cc30')) {
      api.createRecord('0720cc30', component.options)
    } else {
      api.reload('0720cc30', component.options)
    }
    module.hot.accept("./VideoPager.vue?vue&type=template&id=0720cc30&", function () {
      api.rerender('0720cc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/video-pager/VideoPager.vue"
export default component.exports